import Documentation from './Documentation'

export default Documentation



// WEBPACK FOOTER //
// ./src/features/Hotel/components/Documentation/index.js